const benefits = {
  cancellation_policy: {
    title: 'Póliza de cancelación',
    this_is_not_insurance: 'ESTO NO ES UN SEGURO MÉDICO',
    faq: {
      items: [
        {
          title: 'Avisos legales:',
          htmlContent: '<ol><li>Este plan no es una póliza de salud o seguro médico.</li><li>Este plan ofrece descuentos de servicios médicos con ciertos proveedores de salud que forman parte de la red.</li><li>Este plan no realiza pagos directos a los proveedores de servicios médicos.</li><li>El miembro del plan está obligado a pagar por todos los servicios médicos descontados en el momento en que se reciben. Los descuentos pueden variar con base en el servicio, proveedor y área geográfica.</li></ol>'
        },
        {
          title: 'Póliza de Cancelación:',
          htmlContent: 'Para cancelar su membresía, por favor llame al (726) 202-1213 o envíe por correo una solicitud de cancelación dirigida a Member Services P.O. Box 803475, Dallas, TX 75367-1309. Esta carta debe incluir su nombre, número de identificación de membresía y ser enviada por lo menos tres (3) días antes de su próxima fecha de pago. La membresía puede ser cancelada por falta de pago.'
        },
        {
          title: 'Garantía de reembolso en 30 días:',
          htmlContent: 'Si cancela por cualquier razón durante los primeros 30 días después de la fecha en que se hace efectivo su plan, recibirá el reembolso completo del pago hecho por la membresía.'
        },
        {
          title: 'Resolución de quejas:',
          htmlContent: 'Si tiene problemas o reclamos relacionados con el uso de su membresía, por favor llame al (726) 202-1213 para obtener ayuda. Su queja será investigada y en un plazo de 3 días se le dará una resolución.'
        }
      ]
    }
  },
};

export default benefits;
